// cache.interceptor.ts
import { HttpHandlerFn, HttpRequest, HttpResponse, HttpEvent } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { HttpCacheService } from "../service/cache/cache.service";


const CACHE_APIS: string[] = [
  '/api/delivery-drive/type_establishments/',
  '/api/delivery-drive/getAllEstablishment',
  '/api/delivery-drive/mostPopularEstablishments'
];

export function cacheInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Solo cachear GETs
  if (req.method !== 'GET') {
    return next(req);
  }

  // Verificar si la URL debe ser cacheada
  const cacheable = CACHE_APIS.some(url => req.url.includes(url));
  if (!cacheable) {
    return next(req);
  }

  // Obtener el servicio de caché
  const cacheService = inject(HttpCacheService);

  // Verificar si hay datos en caché
  const entry = cacheService['cache'].get(req.url);

  if (entry && entry.expiry > Date.now()) {
    // Crear una respuesta HTTP con los datos cacheados
    const cachedResponse = new HttpResponse({
      body: entry.data,
      status: 200,
      url: req.url
    });

    // Devolver la respuesta cacheada como un Observable
    return of(cachedResponse);
  }

  // Si no hay caché, realizar la petición y almacenar el resultado
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        // Guardar en caché usando set
        cacheService.set(req.url, event.body);
      }
    })
  );
}
